import { render } from "./ModalQnaProductAdd.vue?vue&type=template&id=0dd74f54&scoped=true"
import script from "./ModalQnaProductAdd.vue?vue&type=script&lang=js"
export * from "./ModalQnaProductAdd.vue?vue&type=script&lang=js"

import "./ModalQnaProductAdd.vue?vue&type=style&index=0&id=0dd74f54&scoped=true&lang=css"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd74f54"]])

export default __exports__